import omega3 from './images/omega3.jpg';
import turmeric from './images/turmeric.jpg';
import magnesium from './images/magnesium.jpg';
import probiotic from './images/probiotic.jpg';

export const products = [
  {
    id: 1,
    name: "Omega-3 Fish Oil",
    price: 29.99,
    image: omega3,
    description: "Pure, high-quality omega-3 fatty acids supporting heart and brain health.",
    category: "Essential Fatty Acids"
  },
  {
    id: 2,
    name: "Organic Turmeric",
    price: 24.99,
    image: turmeric,
    description: "Anti-inflammatory and antioxidant support with enhanced absorption.",
    category: "Antioxidants"
  },
  {
    id: 3,
    name: "Magnesium Complex",
    price: 19.99,
    image: magnesium,
    description: "Essential mineral supporting muscle and nerve function.",
    category: "Minerals"
  },
  {
    id: 4,
    name: "Probiotic Plus",
    price: 34.99,
    image: probiotic,
    description: "Advanced gut health formula with prebiotics.",
    category: "Digestive Health"
  }
];